import State from 'store/State';
import { useSelector } from 'react-redux';

export const selectPositionEntryState = (state: State) => state.positionEntry;

export const selectPositionEntryInput = (state: State) =>
    selectPositionEntryState(state).positionInput;

export const selectPositionEntryPosition = (state: State) =>
    selectPositionEntryState(state).position;

export const useSelectPositionEntryInput = () =>
    useSelector(selectPositionEntryInput);

export const useSelectPositionEntryPosition = () =>
    useSelector(selectPositionEntryPosition);
